// ═══════════════════════════════════════════════════════════
// 主程序入口 — 初始化所有模块
// ═══════════════════════════════════════════════════════════

import { initTVMode } from '../ui/tv-mode.js';
import { initSettings } from '../ui/settings.js';
import { initSearch } from './search.js';
import { initHistory } from './history.js';

// 导入副作用模块（它们注册全局函数供其他模块使用）
import './details.js';
import './player-link.js';

function initApp() {
    initTVMode();
    initSettings();
    initSearch();
    initHistory();

    // Service Worker 注册
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    }
}

// 启动
document.addEventListener('DOMContentLoaded', initApp);
